<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'

import HelpersGrid from './HelpersGrid.vue'
import HelperActionRow from './HelperActionRow.vue'
import HelperDebugNewsletterCard from './HelperDebugNewsletterCard.vue'

defineOptions({
  name: 'HelpersNewslettersPage',
})
</script>

<template>
  <HelpersGrid>
    <CardAdmin
      title="Newsletters"
      fullwidth
    >
      <HelperActionRow
        label="Send newsletters"
        route-name="admin.helpers.newsletters.send"
      />
    </CardAdmin>
    <HelperDebugNewsletterCard />
  </HelpersGrid>
</template>
